<template>
  <div class="list-grid" :id="uuid">
    <div class="list-grid-box" @click="showDetail(quickMoveIn, $event)" v-for="quickMoveIn in quickMoveInsWithCoordinates" :key="`${quickMoveIn.id}-${quickMoveIn.slug}`">
      <div class="list-grid-box-image slick-loading">
        <div class="list-slider" :id="`list-slider-${quickMoveIn.id}`">
          <div class="list-slider-slide" v-for="(slide, i) in quickMoveIn.slide_images" :key="`list-slider-slide-${i}`">
            <img :src="slide.url" :alt="slide.title" />
          </div>
        </div>
        <div class="list-grid-box-image-badge align-right">{{ quickMoveIn.availability }}</div>
        <div class="list-detail-slider-controls">
          <button type="button" class="arrow-prev" :id="`arrow-prev-${quickMoveIn.id}`">
            <IconTriangleLeft />
          </button>
          <button type="button" class="arrow-next" :id="`arrow-next-${quickMoveIn.id}`">
            <IconTriangleRight />
          </button>
        </div>
      </div>
      <div class="list-grid-box-title">{{ quickMoveIn.title }}</div>
      <div class="list-grid-box-cost">{{ startingAt(quickMoveIn.price) }}</div>
      <div class="list-grid-box-location">Location: {{ quickMoveIn.location }}</div>
      <div class="list-grid-box-school">School District: {{ quickMoveIn.school_district }}</div>
    </div>
  </div>
</template>

<script>
import IconTriangleLeft from '@/components/icons/IconTriangleLeft';
import IconTriangleRight from '@/components/icons/IconTriangleRight';
import hasSlickSlider from '@/mixins/hasSlickSlider';
import { uuidv4 } from '@/helpers/ui';

export default {
  name: 'QuickMoveInListGrid',
  components: { IconTriangleLeft, IconTriangleRight },
  mixins: [hasSlickSlider],
  data() {
    return {
      sliderClass: '.list-slider',
    };
  },
  watch: {
    quickMoveInsWithCoordinates: {
      handler: function(newQuickMoveIns, oldQuickMoveIns) {
        // console.log('QuickMoveInListGrid watch quickMoveIns()', newQuickMoveIns.length, oldQuickMoveIns.length, this.uuid);
        if (newQuickMoveIns.length !== oldQuickMoveIns.length) {
          this.sliderUpdatePending = true;
        }
      },
    },
    isMapDisplayed: {
      handler: function() {
        // console.log('QuickMoveInListGrid watch isMapDisplayed()', newDisplay, oldDisplay, this.uuid);
        this.resizeSlickSlider(this.uuid);
      },
    },
  },
  computed: {
    isMapDisplayed() {
      return this.$store.getters['ui/isMapDisplayed'];
    },
    quickMoveIns() {
      return this.$store.getters['quickMoveIns/getQuickMoveIns'];
    },
    quickMoveInsWithCoordinates() {
      // console.log('QuickMoveInListGrid quickMoveInsWithCoordinates() filter');
      return this.quickMoveIns.filter((quickMoveIn) => {
        return Array.isArray(quickMoveIn.coordinates);
      });
    },
    uuid() {
      return uuidv4();
    },
  },
  methods: {
    showDetail(quickMoveIn, event) {
      // console.log('QuickMoveInListGrid showDetail()', this.isMapDisplayed, quickMoveIn, event, event.target.className);
      if (this.isMapDisplayed) {
        this.$store.dispatch('ui/setPanelView', { quickMoveIn, panelView: 'detail' });
      } else {
        if (event.target.className !== 'slick-slider-button') {
          window.location = quickMoveIn.link;
        }
      }
    },
    showMap() {
      // console.log('QuickMoveInListGrid showMap()');
      this.$store.dispatch('ui/setMapDisplay', { mapDisplay: true });
    },
    startingAt(price) {
      const thePrice = Number(price.replaceAll(',', ''));
      if (thePrice > 0) {
        const formattedAmount = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0  // Ensures at most two decimal places
        }).format(thePrice);

        return formattedAmount;
      } else {
        return 'Contact Us';
      }
    },
  },
};
</script>
